export enum ErrorType {
    UNAUTHORIZED = "unauthorized",
}

export enum ErrorState {
    NONE = "success",
    ERROR = "error",
    WARNING = "warning",
    INFO = "info",
}
